// extracted by mini-css-extract-plugin
export var box = "_85-1";
export var checkboxRow = "_85-8";
export var checked = "_85-2";
export var descriptionSpacer = "_85-a";
export var disabled = "_85-3";
export var icon = "_85-6";
export var input = "_85-0";
export var labelSpacer = "_85-9";
export var medium = "_85-5";
export var small = "_85-4";
export var text = "_85-7";